export default __webpack_public_path__ + "static/media/btn-videos.bfb4929b.png";